<template>
  <div class="about-page">
    <!-- Banner大图 -->
    <div class="banner">
      <img src="@/assets/wechatMarketing.jpg" alt="banner" />
    </div>

  </div>
</template>

<script>
export default {
  name: 'WechatMarketing'
}
</script>

<style scoped>
/* Banner */
.banner {
  position: relative;
}
.banner img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
